// src/components/common/ModeToggle.jsx
// Twitter/X-style tab bar for switching between "For You" (Dashboard) and "Explore" modes

import React from 'react';
import { MODES } from '../../utils/personaDetection';
import styles from './ModeToggle.module.css';

const ModeToggle = ({ activeMode, onModeChange }) => {
  return (
    <div className={styles.tabBar}>
      <button
        type="button"
        className={`${styles.tab} ${activeMode === MODES.DASHBOARD ? styles.activeTab : ''}`}
        onClick={() => onModeChange(MODES.DASHBOARD)}
        aria-selected={activeMode === MODES.DASHBOARD}
        role="tab"
      >
        <span className={styles.tabLabel}>For you</span>
        {activeMode === MODES.DASHBOARD && <div className={styles.tabIndicator} />}
      </button>

      <button
        type="button"
        className={`${styles.tab} ${activeMode === MODES.EXPLORE ? styles.activeTab : ''}`}
        onClick={() => onModeChange(MODES.EXPLORE)}
        aria-selected={activeMode === MODES.EXPLORE}
        role="tab"
      >
        <span className={styles.tabLabel}>Explore</span>
        {activeMode === MODES.EXPLORE && <div className={styles.tabIndicator} />}
      </button>
    </div>
  );
};

export default ModeToggle;
